import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Inicio", href: "/" },
  { label: "Sobre mí", href: "/sobre-mi" },
  { label: "Ideas", href: "/ideas" },
  { label: "Ponencias", href: "/ponencias" },
  { label: "Contacto", href: "/contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background/95 backdrop-blur-md border-b border-border/60 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.06)]" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" data-testid="navbar-logo" className="font-serif text-lg font-normal tracking-tight text-foreground hover:text-primary transition-colors">
          Eduardo Delgado
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
              className={`label-mono hover:text-primary transition-colors ${
                location.pathname === l.href ? "text-primary" : "text-foreground/70"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/newsletter"
            data-testid="nav-newsletter-cta"
            className="label-mono bg-primary text-primary-foreground px-5 py-2.5 hover:bg-primary/90 transition-colors"
          >
            Newsletter
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          data-testid="navbar-hamburger"
          className="md:hidden p-2 text-foreground"
          onClick={() => setOpen(!open)}
          aria-label="Menú"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-background border-b border-border px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              className={`label-mono text-sm ${location.pathname === l.href ? "text-primary" : "text-foreground/70"}`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/newsletter"
            className="label-mono bg-primary text-primary-foreground px-5 py-3 text-center"
          >
            Newsletter
          </Link>
        </div>
      )}
    </header>
  );
}
